<template>
  <div class="tkIntCabin full-height linear-main3">
    <ld-header
      @click-left="back"
      :transparent="true"
      :white="true"
    >
      <span v-show="flights.length==1&&tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel">{{ $t('C174','去程') }}：</span>
      <span v-show="flights.length>1&&tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel">{{ $t('C175','返程') }}：</span>
      {{ tkIntSearchInfo.depport.cityName }}⇀{{ tkIntSearchInfo.arrport.cityName }}
    </ld-header>
    <div class="box">
      <!-- 舱位列表 -->
      <div class="tkCabinwrapper">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div>
            <tk-int-voyage
              :flights="(tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel==false)?flights:(flights.length>1?[flights[1]]:[flights[0]])"
              :travel-type="tkIntSearchInfo.queryStr.travelType"
              :round-trip="tkIntSearchInfo.roundtrip"
            />
            <van-tabs
              v-model="active"
              line-height="3"
              line-width="50"
            >
              <van-tab v-for="(info ,index1) in cabinTypeList" :key="index1">
                <template #title>
                  <div
                    v-if="info.cabinName"
                    :class="{ 'main-color': (active == index1) }"
                  >
                    <p class="font-bold">
                      {{ info.cabinName }}
                    </p>
                    <!-- <p class="font12 text-center">
                      &yen; {{ info.minPrice }} 起
                    </p> -->
                  </div>
                </template>
                <div
                  class="cabinListBox list-content"
                >
                  <div class="cabinListContent">
                    <div
                      class="van-hairline--top"
                      v-for="(v ,k) in info.priceList"
                      :key="k"
                    >
                      <van-row
                        type="flex"
                        align="center"
                        class="cabinList"
                      >
                        <van-col span="14">
                          <div class="red font12">
                            &yen;<span
                              class="font20">{{ v.aduSalePrice + v.aduTax || v.chdSalePrice + v.chdTax || v.infSalePrice + v.infTax
                            }}</span>
                          </div>
                          <div class="font12">
                            <p class="text-space-1 black">
                              {{ info.cabinName }}/{{ info.cabinCode }} {{ v.discount | discount }}
                            </p>
                            <p
                              class="main-color"
                              @click="showRule(info.cabinCode,v.priceId)"
                            >
                              {{ $t('F010', '退改签规则') }} &gt;
                            </p>
                          </div>
                        </van-col>
                        <van-col span="5">
                          <div
                            class="wei"
                            v-if="tkIntSearchInfo.violateList&&tkIntSearchInfo.violateList[v.priceId]&&tkIntSearchInfo.violateList[v.priceId]['violateItem']"
                          >
                            {{ $t('K303', '违') }}
                          </div>
                          <span class="font10 gray">{{ v.seatNum | seatCount }}</span>
                        </van-col>
                        <van-col span="5">
                          <div
                            class="gray font10"
                            v-if="tkIntSearchInfo.violateList&&tkIntSearchInfo.violateList[v.priceId]&&tkIntSearchInfo.violateList[v.priceId].canBook==0"
                          >
                            {{ $t('Unbookable', '不可预订') }}
                          </div>
                          <ld-button
                            v-else
                            size="md"
                            main
                            @click.native="book(v,info)"
                          >
                            {{ $t('B003', '预订') }}
                          </ld-button>
                        </van-col>
                      </van-row>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
          <nomore />
        </mescroll-vue>
      </div>
    </div>

    <!-- 退改签规则 -->
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      cplx="10902"
    />

    <violate-list
      cplx="10902"
      ref="violateList"
      :violate="tkIntSearchInfo.violate"
      @selected="noTimeOut"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MescrollVue from 'mescroll.js/mescroll.vue'

import nomore from 'Common/ldNoMore'
import ldButton from 'Common/ldButton'
import refundChangeRule from 'Components/refundChangeRule'
import violateList from 'Components/violateList'
import tkIntVoyage from 'Views/TkInt/components/voyage'
import {Tab, Tabs} from 'vant'

export default {
  name:'TkIntCabin',
  components:{
    nomore,
    ldButton,
    refundChangeRule,
    violateList,
    MescrollVue,
    tkIntVoyage,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data () {
    return {
      down:{use:false},
      changeRule:{},//退改规则参数
      active:0
    }
  },
  computed:{
    ...mapGetters({
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
      travelerList: 'tkInt/travelerList',
      tripType: 'tripType',
      userInfo:'userInfo'
    }),
    flights(){//当前航班信息
      let ft=this.tkIntSearchInfo.flights
      let f0=ft[0]
      let f1=ft[1]
      if(ft.length>1){
        return [f0.qflightBean,f1.qflightBean]
      }else if(f0.hflightBean){
        return [f0.qflightBean,f0.hflightBean]
      }
      return [f0.qflightBean]
    },
    cabinTypeList(){//舱位列表
      return this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip].cabinList
    },
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      if (this.tkIntSearchInfo.matchClbz) {
        this.matchClbz()
      }
    },
    //预订
    book(price,cabin){
      //舱位数量
      if(this.tkIntSearchInfo.travelerList){
        let cxrlength = this.tkIntSearchInfo.travelerList.length
        if(price.seatNum<cxrlength){
          this.$toast('您选择的舱位剩余不足，请重新选择舱位，或修改出行人数！')
          return false
        }
      }
      //获取违背信息
      if(this.tkIntSearchInfo.violateList&&Object.keys(this.tkIntSearchInfo.violateList).length>0){
        this.tkIntSearchInfo.violate=this.tkIntSearchInfo.violateList[price.priceId]
      }
      let flights=this.tkIntSearchInfo.flights
      if(this.tkIntSearchInfo.showIntModel){//自由搭配
        flights[this.tkIntSearchInfo.roundtrip].qflightBean.price = price
        flights[this.tkIntSearchInfo.roundtrip].qflightBean.cabin = cabin
      }else{
        if (flights[0].hflightBean) {
          flights[0].hflightBean.price = price
          flights[0].hflightBean.cabin = cabin
          flights[0].hflightBean.flightSn = flights[0].flightSn
          flights[0].hflightBean.flightReqId = flights[0].flightReqId
        }

        flights[0].qflightBean.price = price
        flights[0].qflightBean.cabin = cabin
        flights[0].qflightBean.flightSn = flights[0].flightSn
        flights[0].qflightBean.flightReqId = flights[0].flightReqId
      }
      this.tkIntSearchInfo.flights=flights
      this.$store.commit('tkInt/tkIntSearchInfo',this.tkIntSearchInfo)
      this.noTimeOut()
    },
    noTimeOut(obj){//未超时
      let violate=this.tkIntSearchInfo.violate
      if(violate&&violate.canBook==1){
        if((violate.violateItem||violate.violateCode)&&!violate.reasonDesc){
          this.$refs.violateList.toggle({violate:violate,cplx:'10902'})//选择违背原因
        }else{
          if(this.tkIntSearchInfo.queryStr.travelType==2&&this.tkIntSearchInfo.roundtrip==0&&this.tkIntSearchInfo.showIntModel){
            this.tkIntSearchInfo.roundtrip+=1
            this.$router.push({ path:'/tk/tkIntList' , query:{ text:'我是阿格斯之盾' } })
          }else{
            this.$router.push({ path:this.tkIntSearchInfo.path , query:{ text:'我是阿格斯之盾' } })
          }
        }
      }else if(violate&&violate.canBook==0){
        this.$toast('当前舱位不可预订,因违背' + violate.violateItem)
      }else{
        if(this.tkIntSearchInfo.queryStr.travelType==2&&this.tkIntSearchInfo.roundtrip==0&&this.tkIntSearchInfo.showIntModel){
          this.tkIntSearchInfo.roundtrip+=1
          this.$router.push({ path:'/tk/tkIntList' , query:{ text:'我是阿格斯之盾' } })
        }else{
          this.$router.push({ path:this.tkIntSearchInfo.path , query:{ text:'我是阿格斯之盾' } })
        }
      }
    },
    // 获取是否违背
    matchClbz(){
      let flightReqId =this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip].flightReqId
      if(flightReqId){
        this.$api['tkIntQuery/matchVipClzc']({
          'minZj':this.tkIntSearchInfo.queryStr.empRank||'0',
          'corpId': '',
          'flightReqId': flightReqId  //航班查询请求id不能为空
        }).then(res => {
          let cache = res.data || {}
          this.tkIntSearchInfo.violateList=cache.priceMap||{}
        })
      }
    },
    //显示退改规则
    showRule(cabin,priceId){
      this.changeRule={
        'flightReqId': this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip].requestId,//航班查询请求id不能为空 ,
        'flightSn': this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip].flightSn,//航班序号
        'cabin': cabin,
        'priceId': priceId,
        'cplx':'10902'
      }
      this.$refs.rule.toggle()
    },
    back(){
      this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip].cabinReqId=''
      this.$router.push({path:'/tk/tkIntList'})
    }

  },
  filters: {
    seatCount(seat){//座位
      if(seat=='A'){
        return '充足'
      }else if(typeof(parseInt(seat))==='number'){
        return '余'+seat+'张'
      }else {
        return seat
      }
    },
    discount:function(val){//计算折扣
      if(!val) return
      if (val < 10) {
        return val.toFixed(1) + '折'
      } else if (val == 10) {
        return '全价'
      } else if (val > 10) {
        val = Math.floor(val) / 10
        return val + '倍'
      }else{
        return 0
      }
    }
  }

}

</script>
<style lang="less" scoped>
    @import '~Assets/styles/business';
    .tkIntCabin{
    }
    .box{
        padding: 0 6px;
    }
    .b-r-4{
        border-radius: 4px;
    }
    .pad-b-5{
        padding-bottom: 5px;
    }

    .cabinListBox{
        margin-bottom: 5px;
        .cabinListContent{
            background-color: @color-background-white;
            position: relative;
            .cabinList{
                padding: 14px;
            }
        }
    }
    .indent{
        text-indent: 20px;
    }
    .tkCabinwrapper {
        height: calc(100vh - 50px);
        overflow: hidden;
    }

</style>
